<form [formGroup]="transferForm" class="form theme-form" (ngSubmit)="submitForm()">
  <div class="modal-body">
    <div class="row justify-content-center mb-3">
      <div class="col-12 col-sm-auto">
        <div
          class="toggle-button-group d-flex align-items-stretch position-relative w-100 w-sm-auto overflow-hidden"
          role="group"
          aria-label="Basic radio toggle button group">
          <input
            type="radio"
            class="btn-check"
            name="btnradio"
            id="btnradio1"
            autocomplete="off"
            (change)="
              onOptionChange(
                isCreditAgentMode && profile.userType === PERMISSION_ROLE.ADMIN
                  ? TYPE_TRANSACTIONS.CREDIT
                  : TYPE_TRANSACTIONS.DEPOSIT
              )
            "
            [checked]="
              transaction_type === TYPE_TRANSACTIONS.DEPOSIT ||
              (isCreditAgentMode &&
                profile.userType === PERMISSION_ROLE.ADMIN &&
                transaction_type === TYPE_TRANSACTIONS.CREDIT)
            " />
          <label
            class="btn-custom text-secondary fw-bold text-center d-flex align-items-center justify-content-center w-50 h-100 lh-1 py-2"
            for="btnradio1"
            [ngClass]="{
              'text-white':
                transaction_type === TYPE_TRANSACTIONS.DEPOSIT ||
                (isCreditAgentMode &&
                  profile.userType === PERMISSION_ROLE.ADMIN &&
                  transaction_type === TYPE_TRANSACTIONS.CREDIT),
            }">
            {{
              (isCreditAgentMode && profile.userType === PERMISSION_ROLE.ADMIN
                ? 'transfer.credit'
                : 'words.deposit'
              ) | translate
            }}
          </label>

          <input
            type="radio"
            class="btn-check"
            name="btnradio"
            id="btnradio2"
            autocomplete="off"
            (change)="onOptionChange(TYPE_TRANSACTIONS.WITHDRAWAL)"
            [checked]="transaction_type === TYPE_TRANSACTIONS.WITHDRAWAL" />
          <label
            class="btn-custom text-secondary fw-bold text-center d-flex align-items-center justify-content-center w-50 h-100 lh-1 py-2"
            for="btnradio2"
            [ngClass]="{
              'text-white': transaction_type === TYPE_TRANSACTIONS.WITHDRAWAL,
            }">
            {{ 'words.withdrawal' | translate }}
          </label>

          <div class="glider"></div>
        </div>
      </div>
    </div>

    <app-balance-cards-form
      [balance]="selectedPlayerBalance || selectedUserBalance"
      [credit]="selectedPlayerCredit || selectedUserCredit"
      [currencyCode]="selectedCodeCurrency || selectedCodeCurrencyPlayer"></app-balance-cards-form>

    @if (selectedOption === USER_TYPE.AGENT || selectedOption === USER_TYPE.PLAYER) {
      <div class="row mt-2">
        @if (selectedOption === USER_TYPE.PLAYER) {
          <div class="form-group col-6" appRequiredAsterisk>
            <label for="playerId" class="form-label">
              {{ 'transfer.player' | translate }}
            </label>
            <ng-select
              id="playerId"
              bindLabel="label"
              bindValue="value"
              formControlName="playerId"
              placeholder="{{ 'transfer.placeholders.selectPlayer' | translate }}"
              [items]="players$ | async"
              (change)="onPlayerSelected($event)"
              (search)="onSearchSelect(NG_SELECT_QUERIES.PLAYERS, $event.term)"
              (clear)="onSearchSelect(NG_SELECT_QUERIES.PLAYERS)"
              (close)="onSearchSelect(NG_SELECT_QUERIES.PLAYERS)"
              (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.PLAYERS)"></ng-select>
          </div>
        } @else if (selectedOption === USER_TYPE.AGENT) {
          <div class="form-group col-6" appRequiredAsterisk>
            <label for="agentId" class="form-label">
              {{ 'transfer.agent' | translate }}
            </label>
            <ng-select
              id="agentId"
              bindLabel="label"
              bindValue="value"
              formControlName="agentId"
              placeholder="{{ 'transfer.placeholders.selectAgent' | translate }}"
              [items]="users$ | async"
              (change)="onUserSelected($event)"
              (search)="onSearchSelect(NG_SELECT_QUERIES.USERS, $event.term)"
              (clear)="onSearchSelect(NG_SELECT_QUERIES.USERS)"
              (close)="onSearchSelect(NG_SELECT_QUERIES.USERS)"
              (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.USERS)"></ng-select>
          </div>
        }
        <div class="form-group col-6" appRequiredAsterisk>
          <label for="amount" class="form-label">
            {{ 'transfer.amount' | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            appOnlyNumbersWhitTwoDecimal
            formControlName="amount"
            placeholder="0.00"
            required
            id="amount" />
        </div>
      </div>
    } @else if (selectedOption === USER_TYPE.COLABORATOR) {
      <div class="row mt-2">
        <div class="form-group col-md-4" appRequiredAsterisk>
          <label for="colaboratorId" class="form-label">
            {{ 'transfer.colaborator' | translate }}
          </label>
          <ng-select
            id="colaboratorId"
            bindLabel="label"
            bindValue="value"
            formControlName="colaboratorId"
            placeholder="{{ 'transfer.placeholders.selectColaborator' | translate }}"
            [items]="users$ | async"
            (change)="onUserSelected($event)"
            (search)="onSearchSelect(NG_SELECT_QUERIES.USERS, $event.term)"
            (clear)="onSearchSelect(NG_SELECT_QUERIES.USERS)"
            (close)="onSearchSelect(NG_SELECT_QUERIES.USERS)"
            (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.USERS)"></ng-select>
        </div>
        <div class="form-group col-md-4" appRequiredAsterisk>
          <label for="currencyId" class="form-label">
            {{ 'transfer.currency' | translate }}
          </label>
          <ng-select
            id="currencyId"
            bindLabel="label"
            bindValue="value"
            formControlName="currencyId"
            placeholder="{{ 'transfer.placeholders.selectCurrency' | translate }}"
            [items]="currencies$ | async"
            (search)="onSearchSelect(NG_SELECT_QUERIES.CURRENCIES, $event.term)"
            (clear)="onSearchSelect(NG_SELECT_QUERIES.CURRENCIES)"
            (close)="onSearchSelect(NG_SELECT_QUERIES.CURRENCIES)"
            (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.CURRENCIES)"
            (change)="onCurrencySelected($event)"
            [readonly]="
              profile.userType === PERMISSION_ROLE.AGENT ||
              profile.userType === PERMISSION_ROLE.CASHDESK ||
              profile.userType === PERMISSION_ROLE.COLLABORATOR_AGENT
            "></ng-select>
        </div>
        <div class="form-gruop col-md-4" appRequiredAsterisk>
          <label for="amount" class="form-label">
            {{ 'transfer.amount' | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="amount"
            appOnlyNumbersWhitTwoDecimal
            placeholder="0.00"
            required
            id="amount" />
        </div>
      </div>
    }

    <div class="row mt-2">
      <div class="form-group col-md-12">
        <label for="comment" class="form-label">
          {{ 'transfer.comentary' | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="comment"
          placeholder="{{ 'transfer.placeholders.writeComentary' | translate }}"
          id="comment" />
      </div>
    </div>

    @if (
      selectedOption !== USER_TYPE.PLAYER &&
      transaction_type !== TYPE_TRANSACTIONS.WITHDRAWAL &&
      transaction_type !== TYPE_TRANSACTIONS.CREDIT
    ) {
      <div class="media m-1 label-switch-grid" *appHideForUserTypes>
        <label class="col-form-label">
          {{ 'transfer.typeTransfer' | translate }}
        </label>

        <div class="media-body switch-sm">
          <label class="x-switch">
            <input type="checkbox" (change)="toggleTransactionMode()" [checked]="isCredit" />
            <span class="x-switch__state"></span>
          </label>

          <span class="font-roboto">
            {{ isCredit ? ('transfer.credit' | translate) : ('transfer.cash' | translate) }}
          </span>
        </div>
      </div>
    }
    @if (
      selectedOption !== USER_TYPE.COLABORATOR &&
      !isCredit &&
      transaction_type !== TYPE_TRANSACTIONS.WITHDRAWAL
    ) {
      <div class="media m-1 label-switch-grid" *appHideForUserTypes>
        <label class="col-form-label">
          {{ 'transfer.transferCash' | translate }}
        </label>

        <div class="media-body switch-sm">
          <label class="x-switch">
            <input type="checkbox" (change)="toggleBankingMode()" [checked]="isBanking" />
            <span class="x-switch__state"></span>
          </label>

          <span class="font-roboto">
            {{ isBanking ? ('transfer.banking' | translate) : ('transfer.direct' | translate) }}
          </span>
        </div>
      </div>

      <div class="slide-container" [ngClass]="{ visible: isBanking }">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-md-10">
            <div class="form-group mb-2" appRequiredAsterisk>
              <label for="bankId" class="form-label">
                {{ 'financial.holders.bankName' | translate }}
              </label>
              <ng-select
                id="bankId"
                formControlName="bankId"
                bindLabel="label"
                bindValue="value"
                placeholder="{{ 'financial.holders.bankName' | translate }}"
                [items]="banks$ | async"
                (search)="onSearchSelect(NG_SELECT_QUERIES.BANKS, $event.term)"
                (clear)="onSearchSelect(NG_SELECT_QUERIES.BANKS)"
                (close)="onSearchSelect(NG_SELECT_QUERIES.BANKS)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.BANKS)"></ng-select>
            </div>

            <div class="form-group" appRequiredAsterisk>
              <label class="form-label">
                {{ 'transfer.receipt' | translate }}
              </label>
              <div
                class="card rounded p-3 text-center d-flex flex-column justify-content-center align-items-center cursor-pointer drop-area-container"
                (click)="triggerFileInput()"
                (dragover)="onDragOver($event)"
                (drop)="onDrop($event)">
                <input
                  type="file"
                  class="d-none"
                  formControlName="receipt"
                  accept="image/png,image/jpeg"
                  (change)="onFileSelected($event)"
                  #fileInput />
                @if (!previewImage) {
                  <ng-container>
                    <i class="fa fa-cloud-upload text-secondary mb-3 fs-1"></i>
                    <div class="text-light-emphasis">
                      {{ 'transfer.uploadReceipt' | translate }}
                    </div>
                  </ng-container>
                } @else {
                  <ng-container>
                    <img
                      [src]="previewImage"
                      alt="Vista Previa"
                      class="img-fluid preview-img rounded-3" />
                  </ng-container>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">
      {{ 'btn.cancel' | translate }}
    </button>

    @if (!isBlockButtom) {
      <button
        type="submit"
        class="btn btn-secondary"
        [disabled]="
          transferForm.invalid ||
          isSubmitting ||
          (!isCredit && isBanking && (!transferForm.value.bankId || selectedFiles.length === 0))
        ">
        {{ getButtonLabel() | translate }}
      </button>
    }
  </div>
</form>
